import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrackets2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBrackets2"><Path d="M8.25 3.75H7.75C6.09315 3.75 4.75 5.09315 4.75 6.75V10C4.75 11.1046 3.85457 12 2.75 12C3.85457 12 4.75 12.8954 4.75 14V17.25C4.75 18.9069 6.09315 20.25 7.75 20.25H8.25M15.75 3.75H16.25C17.9069 3.75 19.25 5.09315 19.25 6.75V10C19.25 11.1046 20.1454 12 21.25 12C20.1454 12 19.25 12.8954 19.25 14V17.25C19.25 18.9069 17.9069 20.25 16.25 20.25H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBrackets2;
